@if (loader) {
    <div class="loader"></div> 
}
@if (isShow) {
    <app-header></app-header>
}
<router-outlet></router-outlet>